import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import Input from '../layout/input/Input';
import InputTextArea from '../layout/input/InputTextArea';
import InputDataHora from '../layout/input/InputDataHora';
import InputSelect from '../layout/input/InputSelect';
import TipoNotificacaoEnum from '../../helper/enumerador/TipoNotificacaoEnum';

class DadosMensagem extends AbstractComponent { 
    render() {
        return(    
            <Fragment>
                <div className="col-md-4
                                col-sm-4
                                col-lg-4
                                col-xs-12">
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        id="title"
                        nome="title"
                        maxLength={17}
                        value={this.props.form.title}
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        defaultValue={this.props.form.title}                                                        
                        onChange={e => this.props.onChange(e)}
                    >
                        Título
                    </Input> 

                    <InputSelect
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        id="tipo_notificacao"
                        nome="tipo_notificacao"
                        value={this.props.form.tipo_notificacao}
                        erro={this.props.erroForm.tipo_notificacao}  
                        options={TipoNotificacaoEnum.getOptions()}
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        defaultValue={this.props.form.title}                                                        
                        onChange={e => this.props.onChange(e)}
                    >
                        Tipo de notificação
                    </InputSelect>

                    <InputDataHora
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        id="agendado_para"
                        nome="agendado_para"                        
                        value={this.props.form.agendado_para}
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        defaultValue={this.props.form.agendado_para}
                        onChange={e => this.props.onChange(e)}
                    >
                        Agendar para
                    </InputDataHora> 

                    <InputDataHora
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        id="prazo_limite_envio"
                        nome="prazo_limite_envio"                        
                        value={this.props.form.prazo_limite_envio}
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        defaultValue={this.props.form.prazo_limite_envio}                                                        
                        onChange={e => this.props.onChange(e)}
                    >
                        Prazo limite envio
                    </InputDataHora>   
                </div>

                <div className="col-md-8
                                col-sm-8
                                col-lg-8
                                col-xs-12">
                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        id="body"
                        nome="body"
                        height={"240px"}                                
                        value={this.props.form.body}
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        defaultValue={this.props.form.body}
                        erro={this.props.erroForm.body}                    
                        onChange={e => this.props.onChange(e)}
                    >
                        Corpo da mensagem
                    </InputTextArea>  
                </div>
            </Fragment>
        )
    }
}

export default DadosMensagem;